// First-touch marketing attribution for the contact form, read by Cerebro's
// traffic view. Captured once per browser session rather than read fresh at
// submit time: by the time someone reaches /contact its own query string
// rarely carries the campaign that brought them in — utm params usually
// land on whatever page they clicked through to first, and /contact strips
// its own ?who= param on mount (see contactContext.js), so anything not
// captured immediately would already be gone.

const STORAGE_KEY = 'pa_traffic_context';

function parseUtm(search) {
    const params = new URLSearchParams(search || '');
    const utm = {};
    ['utm_source', 'utm_medium', 'utm_campaign'].forEach((key) => {
        const value = params.get(key);
        if (value) utm[key] = value;
    });
    return utm;
}

export function captureTrafficContext() {
    try {
        if (sessionStorage.getItem(STORAGE_KEY)) return;
        const context = {
            ...parseUtm(window.location.search),
            landingPage: window.location.pathname + window.location.search,
            referrer: document.referrer || '',
        };
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(context));
    } catch (e) {
        // Storage unavailable (private mode, etc) — analytics must not break the app
    }
}

export function getTrafficContext() {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : {};
    } catch (e) {
        return {};
    }
}
